import baseAPI from '@/api/base';
import { EditInvoiceItem, GetInvoiceItem, RegisterInvoiceItem } from '@/dtos/invoice_item.dto';
import {
  DELETE_INVOICE_ITEM_URL,
  EDIT_INVOICE_ITEM_URL,
  GET_INVOICE_ITEM_URL,
  REGISTER_INVOICE_ITEM_URL,
  TOGGLE_INVOICE_ITEM_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class InvoiceItem {
  static getInvoiceItems = async (getInvoiceItem: GetInvoiceItem): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_INVOICE_ITEM_URL, {
      params: getInvoiceItem,
    });
    console.log('response', response);
    return response;
  };

  static registerInvoiceItem = async (
    registerInvoiceItem: RegisterInvoiceItem
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_INVOICE_ITEM_URL, {
      ...registerInvoiceItem,
    });
    console.log('response', response);
    return response;
  };

  static editInvoiceItem = async (editInvoiceItem: EditInvoiceItem): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_INVOICE_ITEM_URL, {
      ...editInvoiceItem,
    });
    return response;
  };

  static toggleInvoiceItemIsActive = async (
    editInvoiceItem: EditInvoiceItem
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_INVOICE_ITEM_IS_ACTIVE_URL,
      {
        ...editInvoiceItem,
      }
    );
    return response;
  };

  static deleteInvoiceItem = async (invoiceItemId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_INVOICE_ITEM_URL}/${invoiceItemId}`
    );
    return response;
  };
}

export default InvoiceItem;

